import PATHS from '../constants';

function fetchServices() {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return fetch(PATHS.HOME_SERVICES, {
        method: 'GET',
        dataType: 'json',
        headers,
    });
};

export default fetchServices;